/** Split the real input value into ordinary text and mentions the reader
 * picked from this menu. An `<input>` cannot style one word; its display
 * layer can, while the input remains the keyboard and screen-reader control. */
export function completedMentionParts(value: string, completed: string[]) {
  const names = [...new Set(completed)]
    .filter((name) => name.trim())
    .sort((a, b) => b.length - a.length);
  if (names.length === 0) return [{ text: value, selected: false }];
  const escaped = names.map((name) => name.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"));
  const matcher = new RegExp(`@(?:${escaped.join("|")})(?=\\s|$)`, "gi");
  const parts: Array<{ text: string; selected: boolean }> = [];
  let last = 0;
  for (const match of value.matchAll(matcher)) {
    const start = match.index ?? 0;
    if (start > last) parts.push({ text: value.slice(last, start), selected: false });
    parts.push({ text: match[0], selected: true });
    last = start + match[0].length;
  }
  if (last < value.length) parts.push({ text: value.slice(last), selected: false });
  return parts.length ? parts : [{ text: value, selected: false }];
}

